import { unrotatePanDelta } from 'utils/satellite-heading';

export function panMapByPointerDelta(
  map: google.maps.Map,
  dx: number,
  dy: number,
  heading: number
): void {
  const delta = unrotatePanDelta(dx, dy, heading);
  map.panBy(-delta.x, -delta.y);
}

export function zoomMapByWheelDelta(
  map: google.maps.Map,
  deltaY: number
): void {
  const zoom = map.getZoom();
  if (zoom === undefined) {
    return;
  }
  map.setZoom(zoom + (deltaY > 0 ? -1 : 1));
}
